<template>
  <div class="mobile_container">
    <div class="top">
      <mt-search
        v-model="Search"
        :result.sync="searchResult"
        cancel-text="取消"
        placeholder="搜索">
      </mt-search>
    </div>

    <div class="content">
      <div class="group">
        <p class="date">6月25号</p>
        <ul>
          <li>
            <div class="img fl">
              <img src="" alt="">
            </div>
            <div class="des">
              <p class="name">
                蔬菜大棚左上角温度计
                <span>5分钟前</span>
              </p>
              <p class="detail">出事啦，这个了，赶紧解决啊！</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'warningList',
    components: {},
    data() {
      return {
        Search: "",
        searchResult: ['视频设备', '传感器', '控制器'],
      }
    },
    mounted: function () {
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .mint-search {
    height: 100%;
  }

  .mint-search-list-warp {
    position: relative;
    z-index: 20;
  }

  div.content {
    div.group {
      p.date {
        background: #F5F6FA;
        width: 100%;
        padding: 0.185rem 0.27rem;
        font-size: 0.22rem;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: 0;
        text-align: left;
      }

      ul {
        li {
          padding: 0.185rem 0.27rem;
          div.img {
            float: left;
            width: 1.59rem;
            height: 1.18rem;
            background: #55a532;
          }
          div.des {
            float: left;
            padding-left: 0.19rem;
            p.name {
              margin-top: 0.25rem;
              font-size: 0.26rem;
              font-weight: 700;
              color: rgba(0, 0, 0, 0.65);
              letter-spacing: 0;
              text-align: left;
              span {
                padding-left: 0.6rem;
                font-size: 0.22rem;
                color: rgba(0, 0, 0, 0.45);
                letter-spacing: 0;
                text-align: left;
              }
            }
            p.detail {
              margin-top: 0.1rem;
              font-size: 0.20rem;
              color: rgba(0, 0, 0, 0.45);
              letter-spacing: 0;
              text-align: left;
            }
          }
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/mobile/warningList.vue